/*
 * Multibuy nudge
 * --------------
 * Keeps "Add 2 more to get 4 for £20" correct as the basket changes, without a
 * page reload.
 *
 * The trigger is a MutationObserver on the header's cart count. Every route
 * that changes the basket updates that bubble — the theme's product form, quick
 * add on the recommendations, and the add-on checkboxes — so watching it catches
 * all of them without patching any of the theme's own JavaScript.
 *
 * The count itself is always recalculated server side, by re-fetching
 * sections/multibuy-progress.liquid, because working out which items are
 * eligible needs product tags and collections that cart.js does not expose.
 */
(function () {
  'use strict';

  const SECTION = 'multibuy-progress';
  const DEBOUNCE_MS = 150;

  class MultibuyProgress extends HTMLElement {
    constructor() {
      super();
      this.refresh = this.refresh.bind(this);
    }

    connectedCallback() {
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;

      this.observer = new MutationObserver(() => {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.refresh, DEBOUNCE_MS);
      });

      this.observer.observe(bubble, { childList: true, subtree: true, characterData: true });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.timer);
    }

    async refresh() {
      const target = this.querySelector('#' + SECTION);
      if (!target) return;

      try {
        const response = await fetch(`${window.location.pathname}?sections=${SECTION}`);
        if (!response.ok) return;

        const json = await response.json();
        const html = json[SECTION];
        if (!html) return;

        const fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('#' + SECTION);
        if (fresh) target.innerHTML = fresh.innerHTML;
      } catch (error) {
        // Leave the last good state on screen.
      }
    }
  }

  if (!customElements.get('multibuy-progress')) {
    customElements.define('multibuy-progress', MultibuyProgress);
  }
})();
